import { render, staticRenderFns } from "./ElementView.vue?vue&type=template&id=78a21179&scoped=true&"
import script from "./ElementView.vue?vue&type=script&lang=ts&"
export * from "./ElementView.vue?vue&type=script&lang=ts&"
import style0 from "./ElementView.vue?vue&type=style&index=0&id=78a21179&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a21179",
  null
  
)

export default component.exports